import qs from 'query-string';

export const getBirthAge = birth => {
  let today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  birth.setFullYear(today.getFullYear());
  if (today < birth) age--;
  return age;
};
export const getAgeToDate = (age, birth) => {
  let years = birth.getFullYear() + age;
  birth.setFullYear(years);
  return birth;
};
export const secondsToTimes = (value, format = [':', ':', '']) => {
  value = parseInt(value);
  let hour = Math.floor(value / 3600);
  let minutes = Math.floor((value - hour * 3600) / 60);
  let seconds = value - hour * 3600 - minutes * 60;
  let covHour = this.formatLpad(hour, 0, '2');
  let covMinutes = this.formatLpad(minutes, 0, '2');
  let covSeconds = this.formatLpad(seconds, 0, '2');
  return `${covHour}${format[0]}${covMinutes}${format[1]}${covSeconds}${format[2]} `;
  // if (this.isEmpty(format)) return `${this.formatLpad(hour, 0, '2')}:${this.formatLpad(minutes, 0, '2')}:${this.formatLpad(seconds, 0, '2')}`
};

export const isoDateToText = strDate => {
  const isoDate = new Date(strDate);
  const year = isoDate.getFullYear();
  const month = ('0' + (isoDate.getMonth() + 1)).slice(-2); // 두 자릿수로 포맷
  const day = ('0' + isoDate.getDate()).slice(-2); // 두 자릿수로 포맷
  return `${year}-${month}-${day}`;
};
export const regDateFormat = strDate => {
  // Date 객체 생성
  const date = new Date(strDate);
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2); // 월은 0부터 시작하므로 +1 해줌
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);

  return `${year}.${month}.${day} ${hours}:${minutes}`;
};
export const objectToQuerystring = obj => qs.stringify(obj);

export default {
  getBirthAge,
  getAgeToDate,
  secondsToTimes,
  objectToQuerystring
};
